import { render, staticRenderFns } from "./DatFastRequest.vue?vue&type=template&id=2f3f6c08&scoped=true&"
import script from "./DatFastRequest.vue?vue&type=script&lang=js&"
export * from "./DatFastRequest.vue?vue&type=script&lang=js&"
import style0 from "./DatFastRequest.vue?vue&type=style&index=0&id=2f3f6c08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3f6c08",
  null
  
)

export default component.exports